export const modulesUrl = {
  falconVS: 'https://falcon.appvelsis.com',
}

export const environment = {
  moduleId: 2,
  version: '1.0.21',
  modulesPath: modulesUrl,
  production: false,
  apiUrl: 'https://dev-nexus.appvelsis.com',
  accountLoginApiUrl: 'https://dev-nexus.appvelsis.com/',

  framework: 'https://hub.appvelsis.com',
};
